'use strict';

module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./~/ng2-charts/~/chart.js/src/charts/Chart.PolarArea.js
// module id = 1504
// module chunks = 21